import React, { useContext } from 'react';
import { SplitFactoryProvider } from '@splitsoftware/splitio-react';

import { SplitReadyContext } from './SplitReadyContext';

/**
 * Provides the idle-loaded Split factory to Split components and hooks below it.
 * Rendered locally by consumers once ready, so the app-wide tree never changes shape.
 */
export const SplitScope: React.FC<React.PropsWithChildren> = ({ children }) => {
    const factory = useContext(SplitReadyContext);
    if (!factory) return null;
    return <SplitFactoryProvider factory={factory}>{children}</SplitFactoryProvider>;
};
